import BugsnagPerformance from '@bugsnag/browser-performance'
import Bugsnag from '@bugsnag/js'

export function initTelemetry() {
	Bugsnag.start({ apiKey: 'b32fc9c3bb72c63a39377a08700d2830' })
	BugsnagPerformance.start({ apiKey: 'b32fc9c3bb72c63a39377a08700d2830' })
}
